module.exports = __webpack_public_path__ + "static/media/YF90_2.ce3fb33e.jpg";